import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { BellRing } from 'lucide-react';
export function Proof() {
  return <SectionWrapper className="bg-brand-dark py-12 md:py-16" data-id="element-203">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-204">
        <div className="bg-gradient-to-r from-brand-card to-brand-darker border border-gray-800 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-205">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-green to-transparent" data-id="element-206"></div>

          <BellRing className="w-12 h-12 text-brand-green mx-auto mb-6 animate-bounce" data-id="element-207" />

          <p className="text-xl md:text-2xl text-white leading-relaxed font-medium" data-id="element-208">
            En solo <span className="text-brand-green font-bold" data-id="element-209">7 días</span>{' '}
            después de enviar tu primera ronda de disputas, recibirás
            notificaciones de que tus datos personales antiguos han sido
            eliminados, preparando el terreno para que las deudas grandes caigan
            como fichas de dominó.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}